import { useRequest } from 'ahooks';
import { useState } from 'react';
import { bannerOperationService, getBannerListService } from './services';
interface editRowProps {
  image?: File;
  linkUrl?: string;
  imageId?: number | string;
}
export default function AdvertisementPictureManagementModel() {
  const [editRow, setEditRow] = useState<editRowProps>({}); // 编辑模式存储当前选中的row数据
  const [bannerHandleType, setBannerHandleType] = useState<string>('add'); // Operation操作项
  const [addBanner, setAddBanner] = useState<boolean>(false); // 添加按钮隐藏展示

  const {
    data: bannerData,
    loading: bannerLoading,
    run: queryBannerList,
    refresh,
  } = useRequest(getBannerListService, {
    manual: true,
  });

  const { loading, runAsync: bannerOperation } = useRequest(
    bannerOperationService,
    {
      manual: true,
    },
  );

  return {
    bannerList: bannerData?.bannerList,
    bannerData,
    bannerLoading,
    loading,
    editRow,
    bannerHandleType,
    addBanner,
    queryBannerList,
    bannerOperation,
    refresh,
    setEditRow,
    setAddBanner,
    setBannerHandleType,
  };
}
